import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Ad Impact")
const _hoisted_2 = { class: "pt-4 p-3 bg-white rounded pb-3" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  id: "purchase-mode-label",
  class: "col-sm-2 col-form-label"
}, "Purchase mode", -1)
const _hoisted_5 = { class: "col-sm-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hashtag" }, null, -1)
const _hoisted_7 = { class: "ml-1" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("legend", { class: "col-form-label col-sm-2 float-sm-left pt-0" }, "Questions", -1)
const _hoisted_11 = { class: "col-sm-10" }
const _hoisted_12 = { class: "list-unstyled" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-backspace" }, null, -1)
const _hoisted_14 = { class: "form-group form-row" }
const _hoisted_15 = ["for"]
const _hoisted_16 = { class: "col-sm-10" }
const _hoisted_17 = { class: "mr-1" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "d-flex items-center justify-content-end" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clone mr-1" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Copy from question ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = ["id", "value", "max"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("legend", { class: "col-form-label col-sm-2 float-sm-left pt-0" }, "options:", -1)
const _hoisted_29 = { class: "col-sm-10" }
const _hoisted_30 = { class: "form-row" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "align-middle ml-2" }, "Shuffle answers", -1)
const _hoisted_32 = { class: "form-row" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "Single answers", -1)
const _hoisted_34 = {
  key: 0,
  role: "separator",
  class: "d-flex justify-content-center"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "d-inline-block py-5 px-1 bg-light mx-auto" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "mt-3 text-center" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" + ")
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "form-group row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", {
  id: "studied-brand-label",
  class: "col-sm-2 col-form-label"
}, "Studied brand", -1)
const _hoisted_42 = { class: "col-sm-10" }
const _hoisted_43 = { class: "form-group row" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("legend", { class: "col-form-label col-sm-2 float-sm-left pt-0" }, "Studied age brackets", -1)
const _hoisted_45 = { class: "col-sm-10" }
const _hoisted_46 = { class: "list-unstyled list-group" }
const _hoisted_47 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_48 = { class: "list-inline" }
const _hoisted_49 = { class: "badge badge-pill badge-dark py-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-tag" }, null, -1)
const _hoisted_51 = { class: "d-flex align-items-center mb-4 d-none" }
const _hoisted_52 = { class: "ml-2" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-times-circle" }, null, -1)
const _hoisted_54 = { class: "p-float-label d-inline-block" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", null, "min", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "-", -1)
const _hoisted_57 = { class: "p-float-label d-inline-block" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", null, "max", -1)
const _hoisted_59 = {
  key: 1,
  class: "list-group-item p-0"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary rounded-circle align-middle mr-2" }, "+", -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode("add ")
const _hoisted_62 = /*#__PURE__*/_createTextVNode(" Create ")


import TooltipDirective from "@/directives/TooltipDirective.js";

const __default__ = {
	directives: {
		tooltip: TooltipDirective
	}
};
import { onBeforeRouteLeave } from "vue-router";
import { computed, reactive, onMounted, ref } from "vue";
import CampaignFormHeader from "@/components/CampaignFormHeader.vue";
import AppButton from "@/components/AppButton.vue";
import FormRow from "@/components/FormRow.vue";
import CampaignTargetGroupsAutocomplete from "@/components/CampaignTargetGroupsAutocomplete.vue";
import Calendar from "primevue/calendar";
import TagInput from "@/components/TagInput.vue";
import AppTextarea from "@/components/AppTextarea.vue";
import AppSwitch from "@/components/AppSwitch.vue";
import AppCard from "@/components/AppCard.vue";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import SelectButton from 'primevue/selectbutton';
import InputNumber from 'primevue/inputnumber';
import { AnswerChoice, Brandlift } from "@/interfaces/Brandlift";
import { PurchaseMode } from "@/interfaces/Campaign";
import axios from "@/api";
import { useDraft } from "@/composables/draft";


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    initialData: null,
    draft: { type: Boolean }
  },
  emits: ["submit", "draft-init"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'submit', formData: Brandlift): void;
	(event: 'draft-init', resetFn: () => void): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	initialData?: Brandlift;
	draft?: boolean;
}





const dropdownChoices = computed((): Array<AnswerChoice> => {
	return formData.questions[0].choices.filter((choice) => !choice.isNone);
});

const ageMin = 18;

let purchaseMode = ref<PurchaseMode>();
let odp = ref<Array<string>>([]);
let opportunityIds = ref<Array<string>>([]);
const formData = reactive<Brandlift>({
	campaign: {
		odp: "",
		format: "/formats/Brandlift",
		advertiser: "",
		name: "",
		targetGroups: [],
		dateStart: undefined,
		dateEnd: undefined,
		purchaseMode: undefined
	},
	questions: [
		{
			"ordinal": 1,
			"title": "Parmi les propositions suivantes, pour lesquelles avez-vous vu de la publicité vidéo en ligne au cours du dernier mois ?",
			"choices": [],
			"isSingleAnswer": false,
			"isShuffledAnswers": true,
			"isCharacterLimitEnabled": true
		},
		{
			"ordinal": 2,
			"title": "Si vous deviez prochainement choisir une marque de [univers] la ou lesquelles choisiriez-vous ?",
			"choices": [],
			"isSingleAnswer": false,
			"isShuffledAnswers": true,
			"isCharacterLimitEnabled": true
		}
	],
	studiedBrand: "",
	respondentGoal: 500,
	isInternalStudy: true,
	studiedAgeBrackets: [
		{
			lowerBound: ageMin,
			upperBound: undefined
		}
	],
	studiedCampaigns: [],
});

if (props.draft) {
	const { resetDraft } = useDraft(formData, (data) => {
		const { campaign, ...additionalFields } = data;

		Object.assign(formData.campaign, campaign);
		Object.assign(formData, additionalFields);

	}, (k, v) => (k.startsWith('date') && v !== null) ? new Date(v) : v);

	emit('draft-init', resetDraft);
}

function onPurchaseModeChange() {
	if (undefined === purchaseMode.value) {
		return;
	}

	switch (purchaseMode.value.code) {
		case 'OTC':
			opportunityIds.value = [];
			break;
		case 'PRG':
			odp.value = [];
			break;
		default:
			odp.value = [];
			opportunityIds.value = [];
			break;
	}
}

function addQuestion() {
	formData.questions.push({
		ordinal: formData.questions.length + 1,
		title: "",
		choices: [],
		isSingleAnswer: false,
		isShuffledAnswers: true,
		isCharacterLimitEnabled: true
	});
}

function removeQuestion(index: number) {
	if (formData.questions.length === 1) {
		return;
	}
	formData.questions.splice(index, 1);
}

function choiceTransform(item: AnswerChoice | string): AnswerChoice | string {
	return (item as AnswerChoice)["@id"] ?? typeof item === "object" ? item : {
		name: item,
		isNone: item.toLowerCase().startsWith('aucun')
	}
}

function toggleCharacterLimit(questionId: number) {
	const question = formData.questions[questionId];
	question.isCharacterLimitEnabled = !question.isCharacterLimitEnabled;
}

function copyChoices(targetIndex: number) {
	const sourceQuestionInput: HTMLInputElement | null = document.querySelector(`input#copy-index-${targetIndex}`);

	if (sourceQuestionInput) {
		formData.questions[targetIndex].choices = [...formData.questions[Number(sourceQuestionInput.value) - 1].choices];
	}
}

function addAgeBracket(): void {
	if (0 === formData.studiedAgeBrackets.length) {
		formData.studiedAgeBrackets.push({
			lowerBound: ageMin,
			upperBound: undefined
		});
	}

	let min = undefined;
	if (formData.studiedAgeBrackets.length) {
		min = formData.studiedAgeBrackets[formData.studiedAgeBrackets.length - 1].upperBound;
	}

	if (typeof min !== 'number') {
		return;
	}

	formData.studiedAgeBrackets.push({
		lowerBound: 1 + min,
		upperBound: undefined
	});
}

function removeAgeBracket(i: number): void {
	formData.studiedAgeBrackets.splice(i, 1);
}

function getLowerBoundMin(i: number): number {
	if (i === 0) {
		return ageMin;
	}

	const prev = formData.studiedAgeBrackets[i - 1];
	if (undefined === prev || undefined === prev.upperBound) {
		return ageMin;
	}

	return 1 + prev.upperBound;
}

function getLowerBoundMax(i: number): number | undefined {
	if (formData.studiedAgeBrackets[i].upperBound) {
		return formData.studiedAgeBrackets[i].upperBound - 1;
	}

	return undefined;
}

function getUpperBoundMin(i: number): number | undefined {
	return formData.studiedAgeBrackets[i].lowerBound + 1;
}

function getUpperBoundMax(i: number): number | undefined {
	const next = formData.studiedAgeBrackets[i + 1];

	if (next && null !== next.lowerBound) {
		return next.lowerBound - 1;
	}

	return undefined;
}

function displayAgeAdd(): boolean {
	if (formData.studiedAgeBrackets.length === 0) {
		return true
	}

	return 'number' === typeof formData.studiedAgeBrackets[formData.studiedAgeBrackets.length - 1].upperBound;
}

onBeforeRouteLeave((
	to,
	from,
	next
) => {
	const isConfirmationRequired = !to.params.success;

	const confirm = () => window.confirm(
		"Do you really want to leave? you have unsaved changes"
	);

	if (!isConfirmationRequired || confirm()) {
		next();
	} else {
		next(false);
	}
});

let purchaseModes = ref<Array<PurchaseMode>>([]);
onMounted(() => {
	axios.get('/purchase_modes').then(res => {
		purchaseModes.value = res.data['hydra:member'];
	});

	if (props.initialData) {
		console.log(props.initialData);
		const { campaign, ...additionalFields } = props.initialData;

		Object.assign(formData.campaign, campaign);
		Object.assign(formData, additionalFields);
	}
});

function submit() {
	const businessIdMap = new Map([
		['OTC', odp],
		['PRG', opportunityIds],
	]);
	formData.campaign.purchaseMode = purchaseMode.value['@id'];
	formData.studiedCampaigns = businessIdMap.get(purchaseMode.value.code)?.value.map((v: string) => ({ businessId: v }));
	emit('submit', formData);
}

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["prevent"])),
    onKeydown: _cache[14] || (_cache[14] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
    "aria-label": "Ad Impact"
  }, [
    _createVNode(CampaignFormHeader, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Dropdown), {
            "aria-labelledby": "purchase-mode-label",
            modelValue: _unref(purchaseMode),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(purchaseMode) ? (purchaseMode).value = $event : purchaseMode = $event)),
            options: _unref(purchaseModes),
            optionLabel: "label",
            loading: 0 === _unref(purchaseModes).length,
            placeholder: 0 === _unref(purchaseModes).length ? 'Loading...' : 'Select purchase mode...',
            class: "form-control",
            onChange: onPurchaseModeChange
          }, null, 8, ["modelValue", "options", "loading", "placeholder"])
        ])
      ]),
      _createVNode(FormRow, {
        label: "Opportunity ID",
        "input-id": "opportunity-id"
      }, {
        default: _withCtx(() => [
          _createVNode(TagInput, {
            "input-id": "opportunity-id",
            modelValue: _unref(opportunityIds),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(opportunityIds) ? (opportunityIds).value = $event : opportunityIds = $event)),
            disabled: 'PRG' !== _unref(purchaseMode)?.code,
            "add-on-blur": "",
            "item-class": "badge-dark rounded-pill"
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(FormRow, {
        label: "ODP media",
        "input-id": "odp-media"
      }, {
        default: _withCtx(() => [
          _createVNode(TagInput, {
            "input-id": "odp-media",
            modelValue: _unref(odp),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(odp) ? (odp).value = $event : odp = $event)),
            disabled: 'OTC' !== _unref(purchaseMode)?.code,
            "add-on-blur": "",
            "item-class": "badge-dark rounded-pill"
          }, {
            item: _withCtx(({ item }) => [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(item), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }),
      _createVNode(FormRow, {
        label: "ODP questionnaire",
        modelValue: _unref(formData).campaign.odp,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formData).campaign.odp) = $event)),
        modelModifiers: { trim: true }
      }, null, 8, ["modelValue"]),
      _createVNode(FormRow, {
        label: "Targets",
        "input-id": "target-groups"
      }, {
        default: _withCtx(() => [
          _createVNode(CampaignTargetGroupsAutocomplete, {
            modelValue: _unref(formData).campaign.targetGroups,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formData).campaign.targetGroups) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormRow, {
        label: "Advertiser",
        modelValue: _unref(formData).campaign.advertiser,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formData).campaign.advertiser) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(FormRow, {
        label: "Campaign name",
        modelValue: _unref(formData).campaign.name,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formData).campaign.name) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(FormRow, { label: "Date start" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Calendar), {
            modelValue: _unref(formData).campaign.dateStart,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(formData).campaign.dateStart) = $event)),
            "date-format": "dd/mm/yy",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormRow, { label: "Date end" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Calendar), {
            modelValue: _unref(formData).campaign.dateEnd,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(formData).campaign.dateEnd) = $event)),
            "date-format": "dd/mm/yy",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(FormRow, { label: "Segment model" }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_unref(SelectButton), {
              modelValue: _unref(formData).isInternalStudy,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(formData).isInternalStudy) = $event)),
              options: [{ name: 'Yes', value: true }, { name: 'No', value: false }],
              "option-label": "name",
              "option-value": "value"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("fieldset", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ol", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).questions, (question, questionIndex) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: questionIndex }, [
                _createElementVNode("li", null, [
                  _createVNode(AppCard, {
                    class: "mb-0",
                    "header-class": "d-flex justify-content-between align-items-center bg-white"
                  }, {
                    "card-header": _withCtx(() => [
                      _createTextVNode(" Question " + _toDisplayString((question.ordinal = questionIndex + 1)) + " ", 1),
                      (questionIndex > 0)
                        ? _withDirectives((_openBlock(), _createBlock(AppButton, {
                            key: 0,
                            class: "btn-light float-right",
                            onClick: ($event: any) => (removeQuestion(questionIndex)),
                            "aria-label": "Remove question"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 2
                          }, 1032, ["onClick"])), [
                            [_directive_tooltip, 'remove this question', "top"]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    "card-body": _withCtx(() => [
                      _createVNode(FormRow, { label: "title" }, {
                        default: _withCtx(() => [
                          _createVNode(AppTextarea, {
                            modelValue: question.title,
                            "onUpdate:modelValue": ($event: any) => ((question.title) = $event),
                            "auto-resize": true,
                            type: "text",
                            class: "form-control mb-1"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", {
                          for: `choices-${questionIndex}`,
                          class: "col-form-label col-sm-2"
                        }, "choices", 8, _hoisted_15),
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(TagInput, {
                            modelValue: question.choices,
                            "onUpdate:modelValue": ($event: any) => ((question.choices) = $event),
                            "input-id": `choices-${questionIndex}`,
                            transform: choiceTransform,
                            characterLimit: question.isCharacterLimitEnabled ? 45 : null,
                            class: "mb-2",
                            "item-class": "badge-dark"
                          }, {
                            item: _withCtx(({ item, itemIndex }) => [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(item.name ?? item), 1),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((question.choices[itemIndex].isNone) = $event),
                                type: "checkbox",
                                class: "mr-1"
                              }, null, 8, _hoisted_18), [
                                [_vModelCheckbox, question.choices[itemIndex].isNone]
                              ]),
                              (question.choices[itemIndex].isNone)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " (unchecks all) "))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue", "input-id", "characterLimit"]),
                          _createElementVNode("div", _hoisted_20, [
                            (questionIndex > 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: "btn btn-link pr-0",
                                  onClick: ($event: any) => (copyChoices(questionIndex))
                                }, _hoisted_24, 8, _hoisted_21))
                              : _createCommentVNode("", true),
                            (questionIndex > 0)
                              ? (_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  id: 'copy-index-' + questionIndex,
                                  value: questionIndex,
                                  type: "number",
                                  min: "1",
                                  max: questionIndex,
                                  class: "text-center btn-link border-0",
                                  style: {"width":"2rem"}
                                }, null, 8, _hoisted_25))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (toggleCharacterLimit(questionIndex)),
                              class: "btn btn-link"
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(['mr-1 fas', question.isCharacterLimitEnabled ? 'fa-lock' : 'fa-unlock'])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(question.isCharacterLimitEnabled ? "Unlock" : "Lock") + " character limit ", 1)
                            ], 8, _hoisted_26)
                          ])
                        ])
                      ]),
                      _createElementVNode("fieldset", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("label", null, [
                              _createVNode(AppSwitch, {
                                modelValue: question.isShuffledAnswers,
                                "onUpdate:modelValue": ($event: any) => ((question.isShuffledAnswers) = $event),
                                class: "align-middle"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _hoisted_31
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("label", null, [
                              _createVNode(AppSwitch, {
                                modelValue: question.isSingleAnswer,
                                "onUpdate:modelValue": ($event: any) => ((question.isSingleAnswer) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _hoisted_33
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                (questionIndex + 1 !== _unref(formData).questions.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_34, _hoisted_36))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_37, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (addQuestion())),
              "aria-label": "Add question",
              class: "btn btn-circle btn-outline-primary"
            }, _hoisted_39)), [
              [_directive_tooltip, 'add a question', "top"]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_unref(Dropdown), {
            modelValue: _unref(formData).studiedBrand,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formData).studiedBrand) = $event)),
            "aria-labelled-by": "studied-brand-label",
            options: _unref(dropdownChoices),
            optionLabel: "name",
            optionValue: "name",
            placeholder: "Select a brand",
            class: "form-control"
          }, null, 8, ["modelValue", "options"])
        ])
      ]),
      _createVNode(FormRow, {
        label: "Respondent Goal",
        modelValue: _unref(formData).respondentGoal,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formData).respondentGoal) = $event)),
        modelModifiers: { number: true },
        type: "number",
        min: "0",
        step: "1"
      }, null, 8, ["modelValue"]),
      _createElementVNode("fieldset", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("ol", _hoisted_46, [
            (_unref(formData).studiedAgeBrackets[0]?.lowerBound)
              ? (_openBlock(), _createElementBlock("li", _hoisted_47, [
                  _createElementVNode("ol", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).studiedAgeBrackets, (bracket, bracketIndex) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'chip-bracket-' + bracketIndex,
                        class: "list-inline-item"
                      }, [
                        _createElementVNode("span", _hoisted_49, [
                          _hoisted_50,
                          _createTextVNode(" " + _toDisplayString(bracket.lowerBound) + _toDisplayString(bracket.upperBound ? '-' : '+') + _toDisplayString(bracket.upperBound) + " ans ", 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formData).studiedAgeBrackets, (bracket, bracketIndex) => {
              return (_openBlock(), _createElementBlock("li", {
                key: 'bracket-' + bracketIndex,
                class: "list-group-item"
              }, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, "Bracket " + _toDisplayString(bracketIndex + 1), 1),
                  _createVNode(_unref(Button), {
                    onClick: ($event: any) => (removeAgeBracket(bracketIndex)),
                    class: "ml-auto p-button-text p-button-light p-button-secondary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_53
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_unref(InputNumber), {
                    modelValue: bracket.lowerBound,
                    "onUpdate:modelValue": ($event: any) => ((bracket.lowerBound) = $event),
                    min: getLowerBoundMin(bracketIndex),
                    max: getLowerBoundMax(bracketIndex),
                    suffix: " ans"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max"]),
                  _hoisted_55
                ]),
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createVNode(_unref(InputNumber), {
                    modelValue: bracket.upperBound,
                    "onUpdate:modelValue": ($event: any) => ((bracket.upperBound) = $event),
                    min: getUpperBoundMin(bracketIndex),
                    max: getUpperBoundMax(bracketIndex),
                    suffix: " ans"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "max"]),
                  _hoisted_58
                ])
              ]))
            }), 128)),
            (displayAgeAdd())
              ? (_openBlock(), _createElementBlock("li", _hoisted_59, [
                  _createVNode(_unref(Button), {
                    onClick: addAgeBracket,
                    class: "p-button-text p-button-light d-block w-100"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_60,
                      _hoisted_61
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(AppButton, {
      onClick: submit,
      class: "btn-block mt-4"
    }, {
      default: _withCtx(() => [
        _hoisted_62
      ]),
      _: 1
    })
  ], 32))
}
}

})